export default "__VITE_ASSET__BDwTXGGN__"